"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatDatePicker = void 0;
var statDateUtil_1 = require("@features/StatisticPage/components/DatePicker/statDateUtil");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var DateRangePicker_1 = require("@/react-app/common/components/DatePicker/DateRangePicker");
exports.StatDatePicker = react_1.default.memo(function (props) {
    var loadStats = props.loadStats, angularJsDependencies = props.angularJsDependencies;
    var urlParams = new URLSearchParams(window.location.search);
    var _a = __read((0, statDateUtil_1.getDefaultValuesFromUrlParams)(urlParams), 2), initialFromDate = _a[0], initialToDate = _a[1];
    var _b = __read((0, react_1.useState)(initialFromDate), 2), fromDate = _b[0], setFromDate = _b[1];
    var _c = __read((0, react_1.useState)(initialToDate), 2), toDate = _c[0], setToDate = _c[1];
    (0, react_1.useEffect)(function () {
        loadStats(fromDate, toDate);
    }, []);
    var updateUrl = function (fromDate, toDate) {
        angularJsDependencies.go('app.assignment.overview.statistics', {
            from: (0, date_fns_1.formatISO)(fromDate),
            to: (0, date_fns_1.formatISO)(toDate),
        }, {
            notify: false,
        });
    };
    var handleFromChange = function (newFrom) {
        if (newFrom) {
            setFromDate(newFrom);
            updateUrl(newFrom, toDate);
            loadStats(newFrom, toDate);
        }
    };
    var handleToChange = function (newTo) {
        if (newTo) {
            setToDate(newTo);
            updateUrl(fromDate, newTo);
            loadStats(fromDate, newTo);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DateRangePicker_1.DateRangePicker, { fromDate: fromDate, setFromDate: handleFromChange, toDate: toDate, setToDate: handleToChange, defaultMinValue: statDateUtil_1.earliestDateAllowed, defaultMaxValue: statDateUtil_1.defaultToValue, dateFormat: "dd MMM yyyy hh:mm a" })));
});
